import { loadStripe } from '@stripe/stripe-js';
import { useEffect, useState } from 'react';

const stripePromises = {
    US: loadStripe(process.env.STRIPE_API_KEY_US),
    CA: loadStripe(process.env.STRIPE_API_KEY_CA),
    US_FND: loadStripe(process.env.STRIPE_API_KEY_US_FND),
    CA_FND: loadStripe(process.env.STRIPE_API_KEY_CA_FND),
};

const useStripeInstances = () => {
    const [stripeInstanceUS, setStripeInstanceUS] = useState();
    const [stripeInstanceCA, setStripeInstanceCA] = useState();
    const [stripeInstanceFoundationUS, setStripeInstanceFoundationUS] = useState();
    const [stripeInstanceFoundationCA, setStripeInstanceFoundationCA] = useState();

    useEffect(() => {
        (async () => {
            setStripeInstanceUS(await stripePromises.US);
            setStripeInstanceCA(await stripePromises.CA);
            setStripeInstanceFoundationUS(await stripePromises.US_FND);
            setStripeInstanceFoundationCA(await stripePromises.CA_FND);
        })();
    }, []);

    return {
        stripePromises,
        stripeInstanceUS,
        stripeInstanceCA,
        stripeInstanceFoundationUS,
        stripeInstanceFoundationCA,
    };
};

export default useStripeInstances;
